import { render, staticRenderFns } from "./SearchCustomer.vue?vue&type=template&id=73cad223"
import script from "./SearchCustomer.vue?vue&type=script&lang=js"
export * from "./SearchCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports